import React, {useEffect, useState} from 'react'
import '../GeneracionFactura/styles/TableBienes.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {ProductosF} from '../../../../interfaces/facturacion.interface'
import {bindActionCreators} from 'redux'
import {actionFacturacionProducto} from '../../../../actions/action-creators'
import {Pagination} from '../../../../components/Pagination'
import TablaFacturacion from '../GeneracionFactura/TablaFacturacion'
import {convertirNumeroConComas} from '../../../../utils/numbers.utils'

const TablaResumen = () => {
  const width: number = useSelector((state: State) => state.userLogin.width)!
  const arrayProductos: Array<ProductosF> = useSelector(
    (state: State) => state.facturacion.arrayProductos
  )
  const calculos = useSelector((state: State) => state.facturacion.calculosArrayProductos)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const checkContribuyente = useSelector(
    (state: State) => state.facturacion.formCliente.checkContribuyente
  )
  const dispatch = useDispatch()
  const {facturacionCalculoTotalArrayProducto} = bindActionCreators(
    actionFacturacionProducto,
    dispatch
  )

  useEffect(() => {
    facturacionCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayProductos])

  return (
    <div className='w-layout-vflex card-content'>
      {width > 990 ? (
        <TablaFacturacion
          datos={calculos}
          arrayProductos={arrayProductos}
          rows={arrayProductos}
          sinAcciones={true}
          idDoc={idDoc}
          checkContribuyente={checkContribuyente}
        />
      ) : (
        <CardBienesServicios
          datos={calculos}
          idDoc={idDoc}
          checkContribuyente={checkContribuyente}
        />
      )}
    </div>
  )
}

const CardBienesServicios = (props: any) => {
  const arrayProductos: Array<ProductosF> = useSelector(
    (state: State) => state.facturacion.arrayProductos
  )
  const [currentItems, setCurrentItems] = useState<Array<any>>([])

  return (
    <>
      {arrayProductos.length > 0 &&
        currentItems.map((producto, i) => <Card key={i} producto={producto} idDoc={props.idDoc} />)}
      {arrayProductos.length > 0 && (
        <Pagination
          data={arrayProductos}
          state={(items: Array<any>) => setCurrentItems(items)}
          items={10}
        />
      )}
      <div className='form-separator'></div>
      <TableResponsiveCard datos={props?.datos} idDoc={props.idDoc}  checkContribuyente={props.checkContribuyente } />
    </>
  )
}

const Card = (props: any) => {
  return (
    <div className='body-card-responsive'>
      <div className='body-card-responsive-row' style={{overflow: 'auto'}}>
        <div data-label='Descripción' className='body-card-responsive-title'>{props.producto.descripcion}</div>
        <div data-label='Subtotal' className='body-card-responsive-title'>
          {props.idDoc === '01'? `$${convertirNumeroConComas(props.producto.total)}`: `$${convertirNumeroConComas(props.producto.subtotal)}`}
        </div>
      </div><div className='form-separator'></div>
      <div className='body-card-responsive-row'>
        <div data-label='Cantidad' className='body-card-responsive-content'>
          <p>Cantidad</p>
          <p>{convertirNumeroConComas(props.producto.cantidad)}</p>
        </div>
        <div data-label='Precio' className='body-card-responsive-content'>
          <p>{props.idDoc === '01' ? 'Precio con IVA' : 'Precio'}</p>
          <p>${convertirNumeroConComas(props.producto.precio)}</p>
        </div>
        <div data-label='Descuento por item' className='body-card-responsive-content'>
          <p>Descuento</p>
          <p style={{color: props.producto.cantidadDescuento !== '0.00' ? '#a90005' : '#1b1b1b'}}>${convertirNumeroConComas(props.producto.cantidadDescuento)}</p>
        </div>
      </div>
    </div>
  )
}

const TableRowResponsiveCard = (props: any) => {
  return (
    <tr>
      <td className='label-column-fact align-end'>
        <div className={props.classNameText} style={{marginRight: '3%'}}>
          {props.text}
        </div>
      </td>
      <td className='total-column-fact align-end'>
        <div className={props.classNameValor}>
          ${convertirNumeroConComas(props?.valor) ?? '0.00'}
        </div>
      </td>
    </tr>
  )
}

const TableResponsiveCard = (props: any) => {
  return (
    <table className='w-100'>
      <tbody>
        <TableRowResponsiveCard classNameText={"div-calculo-p-gray"} text={"Subtotal"} classNameValor={"div-calculo-p-gray"} valor={props?.datos?.subtotal} />
        <TableRowResponsiveCard classNameText={"div-calculo-p-gray"} text={"Descuento"} classNameValor={"div-calculo-p-red"} valor={props?.datos?.descuento} />        
        {props.idDoc !== '01' && <TableRowResponsiveCard classNameText={"div-calculo-p-black"} text={"Impuesto al Valor Agregado 13%"} classNameValor={"div-calculo-p-black"} valor={props?.datos?.totalImpuesto1} />}
        {(props.idDoc !== '01' || props.checkContribuyente === true) && <TableRowResponsiveCard classNameText={"div-calculo-p-black"} text={"Retención 1%"} classNameValor={"div-calculo-p-red"} valor={props?.datos?.totalImpuesto2} />}
        <TableRowResponsiveCard classNameText={"div-calculo-p-black"} text={"Total"} classNameValor={"div-calculo-p-secondary"} valor={props?.datos?.totalConRetecion} />
      </tbody>
    </table>
  )
}

export default TablaResumen
